module.exports = __webpack_public_path__ + "static/media/mo.44f9c555.svg";